const ssoUsersAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    mall_title: i.shopping_center?.title,
    chain: i.chain?.title,
    'chains.title': i.chain?.title,
    'user_roles.title': i?.user_role,
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export const ssoUserItemAdapter = (i) => {
  return {
    ...i,
    mall_title: i.shopping_center?.title,
    chain: i.chain?.title,
  };
};

export default ssoUsersAdapter;
